import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _isArray from "lodash/isArray";
import _mergeWith from "lodash/mergeWith";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.map.js";
import React from 'react';
import { JsonLd } from './JsonLd';
export var JsonLdContext = /*#__PURE__*/React.createContext({});
var transformKeys = {
  FAQ_PAGE: 'FAQPage'
};

var transforms = _defineProperty({}, transformKeys.FAQ_PAGE, function (schemaA, schemaB) {
  var newSchema = {};

  _mergeWith(newSchema, schemaA, schemaB, function (objValue, srcValue) {
    return _isArray(objValue) ? objValue.concat(srcValue) : undefined;
  });

  return newSchema;
});

export var JsonLdContextProvider = function JsonLdContextProvider(_ref) {
  var children = _ref.children;

  var _React$useState = React.useState({}),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      schemas = _React$useState2[0],
      setSchemas = _React$useState2[1];

  var schemaTypes = React.useMemo(function () {
    return Object.keys(schemas);
  }, [schemas]);
  var addToSchemaType = React.useCallback(function (type, schema) {
    setSchemas(function (prev) {
      var newSchemas = prev;

      if (newSchemas[type]) {
        newSchemas[type].push(schema);
      } else {
        newSchemas[type] = [schema];
      }

      return _objectSpread({}, newSchemas);
    });
  }, []);
  var mergedSchemas = React.useMemo(function () {
    return schemaTypes.map(function (type) {
      return schemas[type].reduce(function (accumulator, schema) {
        var transformFunc = transforms[type];
        var newSchema = transformFunc ? transformFunc(accumulator, schema) : schema;
        return newSchema;
      }, {});
    });
  }, [schemaTypes, schemas]);
  return /*#__PURE__*/React.createElement(JsonLdContext.Provider, {
    value: {
      schemas: schemas,
      addToSchemaType: addToSchemaType
    }
  }, children, mergedSchemas === null || mergedSchemas === void 0 ? void 0 : mergedSchemas.map(function (schema) {
    return /*#__PURE__*/React.createElement(JsonLd, null, schema);
  }));
};
export default JsonLdContextProvider;